import React, {
  useEffect,
  useState,
} from "react";

import { useParams } from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaImages,
  FaExpand,
} from "react-icons/fa";

const GalleryDetail = () => {
  const { id } = useParams();

  const [images, setImages] =
    useState([]);

  const [albumName, setAlbumName] =
    useState("");

  const [open, setOpen] =
    useState(false);

  const [preview, setPreview] =
    useState("");

  useEffect(() => {
    /* GET ALBUM IMAGES */
    fetch(
      `https://stjosephweb.ilakshyaerp.in/api/gallery/album/${id}`
    )
      .then((res) => res.json())
      .then((res) =>
        setImages(
          Array.isArray(res)
            ? res
            : []
        )
      );

    /* GET ALBUM NAME */
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/gallery/album"
    )
      .then((res) => res.json())
      .then((res) => {
        const albums =
          Array.isArray(res)
            ? res
            : [];

        const found =
          albums.find(
            (a) =>
              String(a.id) ===
              String(id)
          );

        if (found) {
          setAlbumName(
            found.name
          );
        }
      });
  }, [id]);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#f7f9fc] py-16 border-b border-gray-200">

        <div className="max-w-7xl mx-auto px-5">

          <div className="flex items-center justify-center gap-4 mb-4">

            <div className="w-14 h-14 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-2xl">

              <FaImages />

            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-[#072F5F]">

              {albumName || "Gallery Album"}

            </h1>

          </div>

          <p className="text-center text-gray-500 text-lg">

            Explore memorable moments and school activities

          </p>

        </div>

      </section>

      {/* GALLERY */}
      <section className="bg-[#f7f9fc] py-14">

        <div className="max-w-7xl mx-auto px-5">

          {images.length > 0 ? (

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8">

              {images.map((img) => {

                const imageUrl =
                  `https://stjosephweb.ilakshyaerp.in/uploads/gallery/${img.image}`;

                return (
                  <div
                    key={img.id}
                    className="group bg-white rounded-[28px] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
                    onClick={() =>
                      setPreview(
                        imageUrl
                      )
                    }
                  >

                    {/* IMAGE */}
                    <div className="relative overflow-hidden">

                      <img
                        src={imageUrl}
                        alt=""
                        className="w-full h-[280px] object-cover group-hover:scale-110 transition-all duration-700"
                      />

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-end justify-between p-5">

                        <span className="text-white font-semibold text-lg">

                          School Gallery

                        </span>

                        <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center text-lg">

                          <FaExpand />

                        </div>

                      </div>

                    </div>

                  </div>
                );
              })}
            </div>

          ) : (

            <div className="bg-white rounded-3xl p-16 text-center shadow-md">

              <h2 className="text-3xl font-bold text-[#072F5F] mb-3">

                No Images Available

              </h2>

              <p className="text-gray-500">

                Images will be uploaded soon.

              </p>

            </div>

          )}

        </div>

      </section>

      {/* IMAGE PREVIEW */}
      {preview && (

        <div
          className="fixed inset-0 bg-black/90 z-[99999] flex items-center justify-center p-5"
        >

          {/* CLOSE BUTTON */}
          <button
            onClick={() => setPreview("")}
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white text-black text-2xl font-bold flex items-center justify-center hover:bg-red-500 hover:text-white transition-all duration-300 z-50"
          >
            ✕
          </button>

          {/* IMAGE */}
          <img
            src={preview}
            alt=""
            className="max-w-full max-h-full rounded-2xl shadow-2xl"
          />

        </div>

      )}

      <Footer />
    </>
  );
};

export default GalleryDetail;